/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './accounting-expense-ledger.reducer';

export const AccountingExpenseLedgerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const accountingExpenseLedgerEntity = useAppSelector(state => state.accountingExpenseLedger.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="accountingExpenseLedgerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.detail.title">AccountingExpenseLedger</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.id">Id</Translate>
            </span>
          </dt>
          <dd>{accountingExpenseLedgerEntity.id}</dd>
          <dt>
            <span id="ledgerNo">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.ledgerNo">Ledger No</Translate>
            </span>
            <UncontrolledTooltip target="ledgerNo">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.ledgerNo" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.ledgerNo}</dd>
          <dt>
            <span id="amount">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.amount">Amount</Translate>
            </span>
            <UncontrolledTooltip target="amount">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.amount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.amount}</dd>
          <dt>
            <span id="remarks">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.remarks">Remarks</Translate>
            </span>
            <UncontrolledTooltip target="remarks">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.remarks" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.remarks}</dd>
          <dt>
            <span id="currencyRate">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.currencyRate">Currency Rate</Translate>
            </span>
            <UncontrolledTooltip target="currencyRate">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.currencyRate" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.currencyRate}</dd>
          <dt>
            <span id="settled">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.settled">Settled</Translate>
            </span>
            <UncontrolledTooltip target="settled">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.settled" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.settled ? 'true' : 'false'}</dd>
          <dt>
            <span id="pendingAmount">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.pendingAmount">Pending Amount</Translate>
            </span>
            <UncontrolledTooltip target="pendingAmount">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.pendingAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.pendingAmount}</dd>
          <dt>
            <span id="transactedById">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.transactedById">Transacted By Id</Translate>
            </span>
            <UncontrolledTooltip target="transactedById">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.transactedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.transactedById}</dd>
          <dt>
            <span id="transactedByType">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.transactedByType">Transacted By Type</Translate>
            </span>
            <UncontrolledTooltip target="transactedByType">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.transactedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.transactedByType}</dd>
          <dt>
            <span id="closed">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.closed">Closed</Translate>
            </span>
            <UncontrolledTooltip target="closed">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.closed" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.closed ? 'true' : 'false'}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{accountingExpenseLedgerEntity.entityId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingExpenseLedgerEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.baseCurrency">Base Currency</Translate>
          </dt>
          <dd>{accountingExpenseLedgerEntity.baseCurrency ? accountingExpenseLedgerEntity.baseCurrency.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.category">Category</Translate>
          </dt>
          <dd>{accountingExpenseLedgerEntity.category ? accountingExpenseLedgerEntity.category.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.entityType">Entity Type</Translate>
          </dt>
          <dd>{accountingExpenseLedgerEntity.entityType ? accountingExpenseLedgerEntity.entityType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.accountTransaction">Account Transaction</Translate>
          </dt>
          <dd>{accountingExpenseLedgerEntity.accountTransaction ? accountingExpenseLedgerEntity.accountTransaction.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/accounting-expense-ledger" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/accounting-expense-ledger/${accountingExpenseLedgerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AccountingExpenseLedgerDetail;
